import { connectRouter, routerMiddleware } from 'connected-react-router';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { reducerName } from './reduxMap';
import registryReducer from './registryReducer';

export function configureStore(history, initialState) {
    const middleware = [thunk, routerMiddleware(history)];

    const rootReducer = combineReducers({
        [reducerName]: registryReducer,
        router: connectRouter(history)
    });

    return createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));
}
